module.exports = __webpack_public_path__ + "img/shoot_00033.ac884150.png";